import { compose } from 'recompose';
import NewSalesVatReport from './NewSalesVatReport';
import apiInterceptor from '../../../api/interceptor';
import { newSalesVatApi } from '../../common/base.api';

const composedNewSalesVatReport = compose(apiInterceptor({ ...newSalesVatApi }))(NewSalesVatReport);

export default composedNewSalesVatReport;
